var lib_core = require("lib-core");

var AvatarStateMachine = function(root) {
    var self = this;
    this.root = root;

    lib_core.StateMachine.call(this);

    lib_core.GuiEvents.addEvents({
        AVATAR_BUTTON: {id: 'avatar_1', name: "AVATAR_BUTTON", isGuiButton: true}
    });

    this.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.AVATAR_BUTTON;
        },
        function(cEvent){
            var url = cEvent.data('profile_url');
            var win = window.open(url, '_blank');
            if(win)
                win.focus();
            else
                logError("AssetUpdater", new Error("Could not open profile"), logError.criticality.MAJOR);
        }
    );
}

lib_core.inherit(AvatarStateMachine, lib_core.StateMachine);

module.exports = AvatarStateMachine;